import compass from './compass.png';
import psy from './psy.png';
import shc1 from './shc1.png';
import shc2 from './shc2.png';

export default {
  '0': shc1,
  '1': shc2,
  '2': shc1,
  '3': psy,
  '6': compass,
  '7': compass,
  '8': compass
};
